import React from "react";
import "../styles/Projects.css";
import FolderOpenRoundedIcon from "@material-ui/icons/FolderOpenRounded";
import FadeInSection from "./FadeInSection";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Carousel from "react-bootstrap/Carousel";
import ExternalLinks from "./ExternalLinks";

class Projects extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const spotlightProjects = {
      "Scientific Visualization": {
        title: "Scientific Visualization",
        desc:
          "A project with interactive visualizations of film data, integrating information about films, actors, and popularity trends. These visualizations are accessible through a dynamic web interface.",
        techStack: "Jupiter Notebook",
        link: "https://github.com/Serigne-Mbaye/Scientific-Visualization-Films",
        image: "/assets/SciVis.png"
      },
      "NBA": {
        title: "NBA",
        desc:
          "A web application that provides basic NBA information and player statistics for the regular season.",
        techStack: "Javascript, HTML, CSS",
        link: "https://github.com/AlessandroMangili/NBA",
        image: "/assets/NBA.jpg"
      },
      
    };
    const projects = {
      "Scientific Visualization": {
        desc:
          "Interactive visualizations of film data",
        techStack: "Jupiter Notebook",
        link: "https://github.com/Serigne-Mbaye/Scientific-Visualization-Films",
      },
      "NBA": {
        desc:
          "Web application that provides basic NBA statistics",
        techStack: "Javascript, HTML, CSS",
        link: "https://github.com/AlessandroMangili/NBA",
      },
      "Fallen": {
        desc:
          "A simple free fall ball game.",
        techStack: "JAVA",
        link: "https://github.com/Serigne-Mbaye/Fallen",
      },
      
    };

    return (
      <div id="projects">
        <div className="section-header ">
          <span className="section-title">/ projects</span>
        </div>
        <Carousel>
          {Object.keys(spotlightProjects).map((key, i) => (
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={spotlightProjects[key]["image"]}
                alt={key}
              />
              <div className="caption-bg">
                <Carousel.Caption>
                  <h3>{spotlightProjects[key]["title"]}</h3>
                  <p>
                    {spotlightProjects[key]["desc"]}
                    <p className="techStack">
                      {spotlightProjects[key]["techStack"]}
                    </p>
                  </p>
                  <ExternalLinks
                    githubLink={spotlightProjects[key]["link"]}
                    openLink={spotlightProjects[key]["open"]}
                  ></ExternalLinks>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
        <div className="project-container">
          <ul className="projects-grid">
            {Object.keys(projects).map((key, i) => (
              <FadeInSection delay={`${i + 1}00ms`}>
                <li className="projects-card">
                  <div className="card-header">
                    <div className="folder-icon">
                      <FolderOpenRoundedIcon
                        style={{ fontSize: 35 }}
                      ></FolderOpenRoundedIcon>
                    </div>
                    <ExternalLinks
                      githubLink={projects[key]["link"]}
                      openLink={projects[key]["open"]}
                    ></ExternalLinks>
                  </div>

                  <div className="card-title">{key}</div>
                  <div className="card-desc">{projects[key]["desc"]}</div>
                  <div className="card-tech">{projects[key]["techStack"]}</div>
                </li>
              </FadeInSection>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default Projects;
